import $ from 'jquery';
import enquire from 'enquire.js';
import { config } from '../config';

const options = {
  siteSearchWrapper: '#site-search',
  siteSearchIcon: '.mobile-search-icon',
  siteSearchInput: '#txtSearchTerm',
  siteSearchClear: '#clear-search',
};

const init = () => {
  if ($('.page-wrapper--error-page').length != 1 && $(options.siteSearchInput).length == 1) {
    enquire.register(`screen and (max-width: ${config.breakpoint.mdMax}px)`, {
      match: () => {
        createMobileSearch();
      },
      unmatch: () => {
        destroyMobileSearch();
      },
    });
    createSearchInputListener();
    createClearSearch();
  }
};

const createMobileSearch = () => {
  $(options.siteSearchWrapper).attr('aria-hidden', 'true');

  $(options.siteSearchIcon).each((index, el) => {
    let $this = $(el);

    // add ARIA attributes
    $this.attr('aria-controls', $(options.siteSearchWrapper).attr('ID'));
    $this.attr('aria-expanded', 'false');

    $this.on('click', (event) => {
      let state = $this.attr('aria-expanded') === 'false' ? true : false;
      $(options.siteSearchIcon).attr('aria-expanded', state);
      $(options.siteSearchWrapper).attr('aria-hidden', !state);

      $('html').toggleClass('search-active');

      // set focus on the coresponding other open/close button
      if ($(event.currentTarget).attr('id') === 'mobile-search-icon') {
        // hide elements behind the search overlay from focus
        $('a').not('#site-search a').attr('tabindex', '-1');
        $('a').not('#site-search a').attr('style', 'cursor:default;');
        $('button').not('#site-search button, .mobile-nav-icon, .mobile-search-icon').attr('disabled', 'true');
        $('input').not('#site-search input').attr('disabled', 'true');

        $('#mobile-search-icon-2').focus();

        // hide mobile menu
        if ($('html').hasClass('nav-active')) {
          $('#mobile-nav-icon-2').click();
        }
      } else {
        // restore focus to elements behind the search overlay
        $('a').not('#site-search a').attr('tabindex', '0');
        $('a').not('#site-search a').attr('style', 'cursor:pointer;');
        $('button').not('#site-search button').removeAttr('disabled');
        $('input').not('#site-search input').removeAttr('disabled');
        $('#mobile-search-icon').focus();
      }
    });
  });

  // close mobile menu by pressing escape
  // may need a more centralised approach for handling key codes
  $(window).keyup((e) => {
    if (e.keyCode === 27) {
      e.preventDefault();
      // if mobile nav is open, close it
      if ($('html').hasClass('search-active')) {
        $('html').removeClass('search-active');
        // set focus back on the element that opened the modal
        $('#mobile-search-icon').focus();
      }
    }
  });
};

const destroyMobileSearch = () => {
  // unbind click events
  $(options.siteSearchIcon).off('click');

  // remove ARIA attribute on wrapper
  $(options.siteSearchWrapper).removeAttr('aria-hidden');

  // remove modal state
  $('html').removeClass('search-active');

  // restore focus to elements behind the search overlay
  $('a').not('#site-search a').attr('tabindex', '0');
  $('a').not('#site-search a').attr('style', 'cursor:pointer;');
  $('button').not('#site-search button').removeAttr('disabled');
  $('input').not('#site-search input').removeAttr('disabled');
};

const createSearchInputListener = () => {
  displayClear();
  $(options.siteSearchInput).on('keydown', () => {
    $(options.siteSearchClear).attr('aria-hidden', 'false');
  });
  $(options.siteSearchInput).on('keyup', () => {
    displayClear();
  });
};

const inputHasValue = (input) => $(input).val().length > 0;

const displayClear = () => {
  if (inputHasValue(options.siteSearchInput)) {
    $(options.siteSearchClear).attr('aria-hidden', 'false');
  } else {
    $(options.siteSearchClear).attr('aria-hidden', 'true');
  }
};

const createClearSearch = () => {
  $(options.siteSearchClear).on('click', () => {
    $(options.siteSearchInput).val('');
    $(options.siteSearchClear).attr('aria-hidden', 'true');
  });
};

export { init };
